// extracted by mini-css-extract-plugin
export default {"listContainer":"InvestorJoinContent_listContainer__pkxrh","hoppingHand":"InvestorJoinContent_hoppingHand__9zKwU"};